import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/*
 * © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { styled } from '@mui/system';
import { alpha } from '@mui/material/styles';
import { PROMETHEAN_PURPLE_GRAPE, PROMETHEAN_TEXT, PROMETHEAN_PURPLE_PLUM, PROMETHEAN_DARK_PURPLE, PROMETHEAN_FOCUS_SHADOW } from '../../../../styles/colors/colors';
import { PROMETHEAN_TABLE_SECONDARY } from '../../../../styles/typography/typography';
export var StyledTablePaginationItem = styled('div')(function () {
  return {
    '&.EmbersTablePaginationItem-root': _objectSpread(_objectSpread({}, PROMETHEAN_TABLE_SECONDARY), {}, {
      color: PROMETHEAN_TEXT,
      width: 28,
      height: 28,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
      borderRadius: 8,
      cursor: 'pointer',
      userSelect: 'none',
      outline: 'none',
      '&:hover': {
        border: "1px solid ".concat(PROMETHEAN_PURPLE_PLUM)
      },
      '&:active': {
        backgroundColor: alpha(PROMETHEAN_DARK_PURPLE, 0.2)
      },
      '&:focus': {
        '&:not(&.EmbersTablePaginationItem-clickFocus)': {
          boxShadow: PROMETHEAN_FOCUS_SHADOW + ' inset',
          border: 'none'
        }
      },
      '&.EmbersTablePaginationItem-selected': {
        backgroundColor: alpha(PROMETHEAN_PURPLE_GRAPE, 0.1),
        border: "1px solid ".concat(PROMETHEAN_PURPLE_PLUM)
      }
    })
  };
});